export const symptomItems = [
  {
    icon: "ri-loader-4-line",
    title: "页面一直转圈、进度条卡住",
    desc: "地址栏能输入、域名也能解析，但页面长时间停留在加载状态，最终提示超时。这类情况多是线路拥塞或目标站点当前响应缓慢。",
    level: "连接层",
  },
  {
    icon: "ri-error-warning-line",
    title: "提示“无法访问此网站”或“连接已重置”",
    desc: "浏览器给出 ERR_CONNECTION_RESET、ERR_CONNECTION_TIMED_OUT 之类的提示，通常说明连接在建立阶段就被中断，常见于网络层的拦截。",
    level: "连接层",
  },
  {
    icon: "ri-route-line",
    title: "打开后被跳转到陌生页面",
    desc: "原地址打开后跳到导航页、公告页或完全无关的站点，往往是原域名已经停止使用、被他人接管，属于典型的地址失效信号。",
    level: "域名层",
  },
  {
    icon: "ri-article-line",
    title: "能打开但白屏、只有广告",
    desc: "页面框架加载出来了，正文区域却空白或塞满弹窗广告。可能是页面资源被拦截，也可能访问到的并不是原来的站点。",
    level: "页面层",
  },
  {
    icon: "ri-smartphone-line",
    title: "手机流量能进、家里 WiFi 进不去",
    desc: "同一时间换一种网络就能访问，说明问题多半出在当前这条网络线路上，而不是站点本身，属于网络环境差异导致的差异表现。",
    level: "网络层",
  },
  {
    icon: "ri-shield-cross-line",
    title: "提示站点不安全或需要额外验证",
    desc: "浏览器弹出安全提醒、证书错误，或要求完成人机验证。少数是证书过期，多数是连接被中间环节改写导致。",
    level: "安全层",
  },
];

export const causeItems = [
  {
    tag: "地址",
    title: "域名更换，旧地址已失效",
    desc: "这类站点多依赖不断更换的域名对外提供服务，旧域名停止解析或被回收后，继续使用旧地址自然打不开。先确认手上地址是不是最新，是最优先的一步。",
    accent: "primary",
  },
  {
    tag: "网络",
    title: "运营商或网络层屏蔽",
    desc: "部分地区网络会在解析或连接阶段拦截目标域名，表现为同一地址在不同网络下结果完全不同。判断方法很简单：换一条网络再试一次。",
    accent: "secondary",
  },
  {
    tag: "解析",
    title: "DNS 解析被污染或缓存过期",
    desc: "本机或路由器里保存着旧的 DNS 记录，域名已经更新但本地仍指向旧结果。清掉 DNS 缓存、手动换成公共 DNS 往往能立刻见效。",
    accent: "accent",
  },
  {
    tag: "本机",
    title: "浏览器缓存与扩展程序干扰",
    desc: "长时间不清理的缓存、拦截类或广告类扩展，会误伤页面脚本。用无痕窗口打开是成本最低的验证方式，能打开基本就锁定在本机环境。",
    accent: "primary",
  },
  {
    tag: "设备",
    title: "本地网络、路由器或防火墙问题",
    desc: "路由器长时间运行、家长控制、公司防火墙策略，都可能拦住特定域名。重启路由、换设备对比，能快速把范围缩小到具体环节。",
    accent: "secondary",
  },
  {
    tag: "站点",
    title: "目标站点自身维护或负载过高",
    desc: "也存在与访问者无关的情况：站点并发过高、服务器维护中，表现为所有人都打不开。这种情况只能换时间再试，无法从本地解决。",
    accent: "accent",
  },
];

export const quickCheckTabs = [
  {
    key: "computer",
    label: "电脑浏览器",
    icon: "ri-computer-line",
    items: [
      "先在地址栏完整手动输入地址，不要通过历史记录或书签打开，避免用到失效的旧链接。",
      "按 Ctrl + Shift + R（Mac 为 Cmd + Shift + R）强制刷新，忽略本地缓存重新加载。",
      "打开无痕窗口再试一次，用来区分是缓存/扩展问题还是地址本身问题。",
      "换一个浏览器对比，例如从常用的浏览器换到系统自带浏览器。",
      "检查地址是否被自动补全成了其他网站，确认域名后缀完全一致。",
    ],
  },
  {
    key: "mobile",
    label: "手机与平板",
    icon: "ri-smartphone-line",
    items: [
      "在 WiFi 和移动数据之间切换，判断问题是否只出现在某一条网络上。",
      "关闭浏览器并清理一次缓存，或直接在系统浏览器中重新输入地址。",
      "确认没有开启省流/极速模式或第三方拦截类应用。",
      "复制地址到系统浏览器打开，排除内置浏览器或社交软件的兼容问题。",
      "检查手机时间是否准确，时间偏差过大也会触发部分证书校验失败。",
    ],
  },
  {
    key: "network",
    label: "网络与路由器",
    icon: "ri-router-line",
    items: [
      "重启光猫与路由器，等待指示灯稳定后再测试。",
      "把设备 DNS 手动改为公共 DNS（如 223.5.5.5、1.1.1.1）后重试。",
      "清除本机 DNS 缓存：Windows 用 ipconfig /flushdns，Mac 重启或刷新 DNS。",
      "换一台设备连接同一条网络，判断是整条网络还是单台设备的问题。",
      "如果公司或校园网络无法访问，换家庭网络对比即可确认是否为网络策略限制。",
    ],
  },
];

export const troubleshootSteps = [
  {
    step: "01",
    title: "确认地址是否为最新",
    desc: "先从地址本身入手：确保输入完整、没有多余空格、后缀正确，并且不是从旧的收藏或历史记录进入。地址是否有效，是所有后续排查的前提。",
    time: "约 1 分钟",
  },
  {
    step: "02",
    title: "换网络环境对比",
    desc: "用移动数据与 WiFi 分别打开同一地址。如果只有某一条网络打不开，问题基本锁定在网络线路或运营商一侧，而不是站点故障。",
    time: "约 2 分钟",
  },
  {
    step: "03",
    title: "清除缓存与 DNS",
    desc: "清理浏览器缓存、以无痕模式打开，并刷新本机 DNS 缓存。这一步能排除绝大多数“本地还记着旧地址”的假性故障。",
    time: "约 3 分钟",
  },
  {
    step: "04",
    title: "关闭扩展与拦截软件",
    desc: "暂时停用广告拦截、安全防护、代理类扩展与软件。它们会把正常页面脚本当成风险内容拦截，造成白屏或加载中断。",
    time: "约 2 分钟",
  },
  {
    step: "05",
    title: "更换 DNS 解析",
    desc: "把设备或路由器的 DNS 换成公共 DNS 服务，绕开可能被污染或过期的解析结果，再重新打开目标地址。",
    time: "约 4 分钟",
  },
  {
    step: "06",
    title: "更换设备与浏览器交叉验证",
    desc: "用另一台设备、另一个浏览器访问，形成对照。如果换设备就能打开，说明是原设备环境问题；都打不开则更可能是网络或地址问题。",
    time: "约 3 分钟",
  },
  {
    step: "07",
    title: "确认是站点侧还是访问侧",
    desc: "通过公开的网站可用性检测或向其他人询问同一时间的访问结果，判断是全网都打不开，还是只有你所在网络打不开。",
    time: "约 3 分钟",
  },
  {
    step: "08",
    title: "换时间重试并记录现象",
    desc: "排除本地因素后，间隔一段时间再试。同时记录下具体报错文字与发生时间，便于判断是偶发拥塞还是持续性问题。",
    time: "视情况",
  },
];

export const addressGuidePoints = [
  {
    title: "为什么地址会突然失效",
    desc: "这类站点常通过不断切换域名来维持访问，旧域名会在一段时间后停止解析或转作他用。用户手中保存的地址随之失效，是很常见的现象。",
  },
  {
    title: "如何判断手上地址已作废",
    desc: "打开后跳转到明显无关的页面、显示域名出售信息、或解析到完全不相关的站点，基本可以判断该地址已不再指向原站点。",
  },
  {
    title: "看到“新地址”时要多留个心眼",
    desc: "会有人抢先注册相似域名冒充原站。遇到要求下载安装包、输入账号密码或付款的页面，应先怀疑其真实性，不要盲目操作。",
  },
  {
    title: "以官方或稳定渠道为准",
    desc: "与其不断追新域名，不如以长期稳定、可核实的渠道获取信息。来源不明的“最新地址”本身就是常见的安全风险来源。",
  },
];

export const networkFactors = [
  {
    icon: "ri-global-line",
    title: "解析阶段被拦截",
    desc: "域名在解析环节就返回错误或被指向无关地址，此时浏览器还没真正开始请求页面内容就已经失败了。",
  },
  {
    icon: "ri-plug-line",
    title: "连接阶段被中断",
    desc: "解析正常但连接被重置，表现为一直加载后提示连接失败，这类通常发生在网络对连接的干预环节。",
  },
  {
    icon: "ri-time-line",
    title: "高峰时段线路拥塞",
    desc: "晚间高峰期跨境或跨网线路容易拥堵，同一地址白天能用、晚上打不开，多半与线路负载有关。",
  },
  {
    icon: "ri-building-line",
    title: "单位或校园网络策略",
    desc: "公司、学校的出口网络往往有统一的访问策略，同一地址在家庭网络可用、在单位不可用属于正常差异。",
  },
];

export const safetyTips = [
  {
    icon: "ri-download-2-line",
    title: "不要随意下载“加速器”或安装包",
    desc: "为打开某个页面而安装来路不明的程序，是当前最常见的中招途径。真正需要的是一个可靠来源，而不是临时下载的可执行文件。",
    tone: "accent",
  },
  {
    icon: "ri-lock-password-line",
    title: "不要输入账号、密码与支付信息",
    desc: "正规的信息查询不需要反复索取账号密码或银行卡信息。遇到此类页面，应直接关闭，避免账号被盗用。",
    tone: "primary",
  },
  {
    icon: "ri-eye-off-line",
    title: "警惕仿冒与钓鱼页面",
    desc: "相似域名、拼写相近的网址是仿冒页面的典型特征。打开前先核对域名拼写，是成本极低却非常有效的习惯。",
    tone: "secondary",
  },
  {
    icon: "ri-hand-heart-line",
    title: "通过正规渠道获取内容",
    desc: "对于影视内容，通过正规授权的平台观看，既稳定可靠，也能避免恶意页面、弹窗广告与隐私泄露等连带风险。",
    tone: "primary",
  },
];

export const faqItems = [
  {
    q: "秋霞影院打不开，最先应该检查什么？",
    a: "先确认手上的地址是否还是最新、是否从旧收藏进入，再用另一条网络（例如从 WiFi 换成移动数据）打开同一地址。这两步就能把“地址问题”和“网络问题”区分开，之后的排查都会更有方向。",
  },
  {
    q: "为什么手机流量能打开，家里 WiFi 却不行？",
    a: "这通常说明问题出在具体的网络线路上，而不是站点本身。可以先重启路由器、把 DNS 换成公共 DNS，再换一台设备连接同一条网络对比，基本就能判断是整条网络还是单台设备的问题。",
  },
  {
    q: "提示“连接已重置”是什么意思？",
    a: "这表示连接在建立或传输过程中被中断，页面内容还没来得及完整加载。它多与当前网络环境有关，换一条网络或更换 DNS 后再试，往往就能得到不同结果。",
  },
  {
    q: "清理缓存和 DNS 真的有用吗？",
    a: "有用，而且成本很低。本机浏览器和路由器会缓存旧的解析结果与页面文件，当域名已经变化时，本地仍可能按旧记录访问。清理缓存、刷新 DNS、用无痕模式打开，是排除本地因素的快捷方式。",
  },
  {
    q: "换了 DNS 还是打不开怎么办？",
    a: "可以先关闭广告拦截与安全类扩展，改用无痕窗口或另一个浏览器，再换设备交叉验证。如果同一网络下所有设备都打不开，而其他网络可以，那问题基本在网络侧；如果所有网络都不行，则更可能是地址或站点自身的问题。",
  },
  {
    q: "网上流传的“最新地址”能直接信吗？",
    a: "建议谨慎。有人会注册相似域名冒充原站，借“最新地址”的名义诱导下载或填写信息。判断时先核对域名拼写，凡是要求安装程序、输入账号密码或付款的页面，都应先怀疑再操作。",
  },
  {
    q: "网页进不去和网站被屏蔽有什么区别？",
    a: "网页进不去是一个结果，可能是地址失效、缓存错误、设备问题等；网站被屏蔽是其中一种具体原因，指访问在解析或连接阶段被拦截。要区分两者，关键还是用换网络、换设备的方法做交叉对比。",
  },
  {
    q: "页面能打开却只有广告和白屏，是怎么回事？",
    a: "常见原因是页面资源被拦截，或访问到的并不是原来的站点。可以尝试关闭拦截类扩展、清除缓存后重新打开；如果仍是同样结果，就要提高警惕，确认该地址是否已经不再指向原来的内容。",
  },
];

export const glossaryItems = [
  { term: "DNS", desc: "把域名翻译成服务器地址的“电话本”，记录过期会导致访问指向错误位置。" },
  { term: "缓存", desc: "浏览器与系统保存的临时文件，能加速访问，但也可能保存了过期的地址与页面。" },
  { term: "无痕模式", desc: "不读取原有缓存与扩展的浏览方式，用于快速判断问题是否出在本机环境。" },
  { term: "连接重置", desc: "连接在传输过程中被中断，页面无法完整加载，多与当前网络环境有关。" },
  { term: "公共 DNS", desc: "面向公众提供的解析服务，可用于排除本地解析被污染或过期的情况。" },
];